import { Inject, Injectable } from '@angular/core';
import { Stay } from '@shared/models';
import { StayAlertService } from './stay-alert.service';
import { computeStayMerge, StayMergeResult } from '@mobile/utils';
import { CWT_APP_CONFIG, CwtAppConfig } from '@mobile/modules/core/core-app.config';

@Injectable({ providedIn: 'root' })
export class StayMergeService {
  constructor(
    @Inject(CWT_APP_CONFIG) private config: CwtAppConfig,
    private stayAlert: StayAlertService
  ) { }

  public async handleMerge(stay: (Partial<Stay> | Stay), otherStays: Stay[]) {
    const data = computeStayMerge(stay, otherStays);
    if(this.config.stay.useDates) {
      const shouldMerge = await this._confirmMergeIfAny(data);
      return shouldMerge ? data : null;
    } else {
      return data;
    }
  }

  private _confirmMergeIfAny(mergeData: StayMergeResult) {
    if (mergeData?.shouldMerge) return this.stayAlert.confirmStayMerge(mergeData.staysToMerge, mergeData.mergeRange);
    if (mergeData?.staysOverlapping?.length) return this.stayAlert.confirmStayOverlap(mergeData.staysOverlapping);
    return true;
  }
}
